import { render } from "./TestimoniosUsuarios.vue?vue&type=template&id=18de764d&scoped=true"
import script from "./TestimoniosUsuarios.vue?vue&type=script&lang=js"
export * from "./TestimoniosUsuarios.vue?vue&type=script&lang=js"

import "./TestimoniosUsuarios.vue?vue&type=style&index=0&id=18de764d&scoped=true&lang=css"
import "./TestimoniosUsuarios.vue?vue&type=style&index=1&id=18de764d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18de764d"]])

export default __exports__